/* eslint-disable indent */
import React, { useEffect, useMemo } from 'react'
import { ModalFeedbackUnicoTemplate } from 'redesign/components/molecules/ModalFeedbackUnicoTemplate'
import illustrationDuvidas from 'assets/illustration-unico-modal.svg'

import { Illustrator, Text } from './styles'
import { useTracking } from 'react-tracking'

type SignUpModalLimitExceededProps = {
    setShowModal: (value: boolean) => void
    showModal: boolean
    hasCipPassword?: boolean
}

export const ModalFeedbackUnico = ({ setShowModal, showModal, hasCipPassword = true }: SignUpModalLimitExceededProps) => {
    const { trackEvent } = useTracking()

    const title = hasCipPassword ? 'O reconhecimento facial atingiu o limite de tentativas' : 'Sem acesso aos contatos?'
    const currentStepText = hasCipPassword ? 'Modal - Limite de tentativas' : 'Modal - Sem acesso aos contatos'

    const {
        location: { href: url },
    } = window

    const fluxoAtual = useMemo(
        () =>
            url.includes('otp')
                ? 'Login OTP'
                : url.includes('recuperar-senha')
                ? 'Reset de senha'
                : url.includes('mdm')
                ? 'Cadastro'
                : undefined,
        [url],
    )

    useEffect(() => {
        showModal &&
            trackEvent({
                event: 'funnel_step',
                funnel: {
                    name: fluxoAtual,
                    current_step: currentStepText,
                    origin: fluxoAtual,
                },
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showModal])

    return (
        <ModalFeedbackUnicoTemplate
            setShowModal={() => {
                setShowModal(!showModal)
            }}
            showModal={showModal}
            title={title}
        >
            <Text>
                Para sua segurança, peça ajuda da nossa <strong>central de atendimento</strong> pelo <strong>WhatsApp</strong> pra
                cadastrar um novo contato.
            </Text>

            <Illustrator alt="Ilustração de dúvidas" src={illustrationDuvidas} />
        </ModalFeedbackUnicoTemplate>
    )
}
